import type { ReactNode } from 'react';
import { cn } from './utils';

export interface EmptyStateProps {
  readonly title: string;
  /**
   * O que fazer a seguir. Obrigatório por contrato de tipo: estado vazio sem
   * orientação é um beco sem saída — o usuário não sabe se falta permissão, se
   * o filtro é restritivo demais, ou se simplesmente não há nada cadastrado.
   */
  readonly description: string;
  readonly icon?: ReactNode;
  readonly action?: ReactNode;
  readonly secondaryAction?: ReactNode;
  readonly className?: string;
  readonly variant?: 'default' | 'compact';
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  secondaryAction,
  className,
  variant = 'default',
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        variant === 'default' ? 'gap-3 px-6 py-14' : 'gap-2 px-4 py-8',
        className,
      )}
    >
      {icon ? (
        <span
          aria-hidden="true"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-sunken text-content-subtle"
        >
          {icon}
        </span>
      ) : null}
      <h3 className="text-base font-semibold text-content">{title}</h3>
      <p className="max-w-md text-sm text-content-muted">{description}</p>
      {action || secondaryAction ? (
        <div className="mt-1 flex flex-wrap items-center justify-center gap-2">
          {action}
          {secondaryAction}
        </div>
      ) : null}
    </div>
  );
}
